Monitoring.Models.SocialContents ||= {}
class Monitoring.Models.SocialContents.AnalysisUnitFactory

  create: (serializedAnalysisUnit, allTags) ->
    return @_createLegacy(serializedAnalysisUnit, allTags) unless serializedAnalysisUnit.data

    subType = serializedAnalysisUnit.data.sub_type
    origin = serializedAnalysisUnit.origin || serializedAnalysisUnit.data.origin

    if subType == 'webchat-message'
      @_createWebchatMessage(serializedAnalysisUnit, allTags)
    else if subType == 'webchat-start'
      @_createWebchatStart(serializedAnalysisUnit, allTags)
    else if subType == 'claim-message'
      @_createClaimMessage(serializedAnalysisUnit, allTags)
    else if subType == 'google_search_result'
      @_createGoogleSearch(serializedAnalysisUnit, allTags)
    else if serializedAnalysisUnit.data.type == 'cem_survey_response'
      @_createCemSurveyResponse(serializedAnalysisUnit, allTags)
    else if subType == 'ig-message'
      @_createInstagramPrivateMessage(serializedAnalysisUnit, allTags)
    else if subType == 'gp_review_comment'
      @_createGPReviewMessage(serializedAnalysisUnit, allTags)
    else if subType == 'apple_app_store_review_comment'
      @_createAppleStore(serializedAnalysisUnit, allTags)
    else if subType == 'instagram_listening_media' || origin == 'instagram_listening_media'
      @_createInstagramListening(serializedAnalysisUnit, allTags)
    else if subType == 'whatsapp_message'
      @_createWhatsappMessage(serializedAnalysisUnit, allTags)
    else if subType == 'yt-video'
      @_createYoutubeVideoContent(serializedAnalysisUnit, allTags)
    else if subType == 'li-post'
      @_createLinkedInPostContent(serializedAnalysisUnit, allTags)
    else if subType == 'li-comment'
      @_createLinkedInCommentContent(serializedAnalysisUnit, allTags)
    else if subType == Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReviewContent.SUB_TYPE
      @_createGoogleMyBusinessReviewContent(serializedAnalysisUnit, allTags)
    else if subType == Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessReplyContent.SUB_TYPE
      @_createGoogleMyBusinessReplyContent(serializedAnalysisUnit, allTags)
    else if subType == 'instagram_business_discovery_listening_media' || origin == 'instagram_business_discovery_api'
      @_createInstagramBusinessDiscoveryListeningContent(serializedAnalysisUnit, allTags)
    else
      @_createLegacy(serializedAnalysisUnit, allTags)

  _createWebchatMessage: (serializedAnalysisUnit, allTags) ->
    start_data = serializedAnalysisUnit.data.message
    if serializedAnalysisUnit.data.interaction
      start_data = _.extend(start_data, {author: serializedAnalysisUnit.data.interaction.author})
    content = new Monitoring.Models.SocialContents.WebchatMessage(start_data)
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags })
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createWebchatStart: (serializedAnalysisUnit, allTags) ->
    start_data = serializedAnalysisUnit.data.start
    start_data = _.extend(start_data, {author: serializedAnalysisUnit.data.interaction.author})
    content = new Monitoring.Models.SocialContents.WebchatStart(start_data)
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags });
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createClaimMessage: (serializedAnalysisUnit, allTags) ->
    content = new Monitoring.Models.SocialContents.ClaimMessage(serializedAnalysisUnit.data)
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags })
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createGoogleSearch: (serializedAnalysisUnit, allTags) ->
    content = new Monitoring.Models.SocialContents.GoogleSearchContent(serializedAnalysisUnit.data)
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags });
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createCemSurveyResponse: (serializedAnalysisUnit, allTags) ->
    content = new Monitoring.Models.SocialContents.CemSurveyResponseContent(serializedAnalysisUnit.data)
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags });
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createAppleStore: (serializedAnalysisUnit, allTags) ->
    content = new Monitoring.Models.SocialContents.Apple.AppleStoreContent(serializedAnalysisUnit.data)
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags });
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createGPReviewMessage: (serializedAnalysisUnit, allTags) ->
    contentData = $.extend({}, serializedAnalysisUnit.data, {interaction_id: serializedAnalysisUnit.interaction_id})
    content = new Monitoring.Models.SocialContents.ReviewComment(contentData)
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags })
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createInstagramPrivateMessage: (serializedAnalysisUnit, allTags) ->
    data = serializedAnalysisUnit.data
    parser = new Models.Parsers.InstagramMessageContentParser
    return @_createInstagramMessage(parser, serializedAnalysisUnit, allTags) if parser.canHandle(data)
    @_createInstagramDM(serializedAnalysisUnit, allTags)

  _createInstagramDM: (serializedAnalysisUnit, allTags) ->
    contentFactory = new Monitoring.Models.SocialContents.InstagramDMContentFactory()
    content = contentFactory.create(serializedAnalysisUnit.data)
    tags = allTags
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      content: content,
      possibleTags: tags
    )
    new Monitoring.Models.SocialContents.AnalysisUnit attributes

  _createInstagramMessage: (parser, serializedAnalysisUnit, allTags) ->
    content = parser.parse(serializedAnalysisUnit.data)
    tags = allTags
    attributes = $.extend({}, serializedAnalysisUnit, content: content, possibleTags: tags)
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createWhatsappMessage: (serializedAnalysisUnit, allTags) ->
    contentFactory = new Monitoring.Models.SocialContents.WhatsappContentFactory()
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      {content: contentFactory.create(serializedAnalysisUnit.data),
      possibleTags: allTags}
    )
    new Monitoring.Models.SocialContents.AnalysisUnit attributes

  _createYoutubeVideoContent: (serializedAnalysisUnit, allTags) ->
    contentFactory = new Monitoring.Models.SocialContents.YoutubeVideoContentFactory()
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      {content: contentFactory.create(serializedAnalysisUnit.data),
      possibleTags: allTags}
    )
    new Monitoring.Models.SocialContents.AnalysisUnit attributes

  _createInstagramBusinessDiscoveryListeningContent: (serializedAnalysisUnit, allTags) ->
    data = serializedAnalysisUnit.data
    media = new Monitoring.Models.SocialContents.InstagramBusinessDiscoveryMedia(data)
    author = new Monitoring.Models.SocialContents.InstagramBusinessDiscoveryAuthor(data.author)
    content = new Monitoring.Models.SocialContents.InstagramBusinessDiscoveryListeningContent(media, author)
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      {content: content, possibleTags: allTags}
    )
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createLinkedInPostContent: (serializedAnalysisUnit, allTags) ->
    postSerializer = new Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInPostSerializer()
    linkedInPostContent = postSerializer.deserialize(serializedAnalysisUnit.data)
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      {content: linkedInPostContent, possibleTags: allTags}
    )
    new Monitoring.Models.SocialContents.AnalysisUnit attributes


  _createLinkedInCommentContent: (serializedAnalysisUnit, allTags) ->
    commentSerializer = new Monitoring.Models.SocialContents.LinkedIn.Serializers.LinkedInCommentSerializer()
    linkedInCommentContent = commentSerializer.deserialize(serializedAnalysisUnit.data)
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      {content: linkedInCommentContent, possibleTags: allTags}
    )
    new Monitoring.Models.SocialContents.AnalysisUnit attributes

  _createGoogleMyBusinessReviewContent: (serializedAnalysisUnit, allTags) ->
    reviewParser = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReviewContentParser
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      {content: reviewParser.parse(serializedAnalysisUnit.data), possibleTags: allTags}
    )
    new Monitoring.Models.SocialContents.AnalysisUnit attributes

  _createGoogleMyBusinessReplyContent: (serializedAnalysisUnit, allTags) ->
    reviewParser = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReplyContentParser
    attributes = $.extend(
      {},
      serializedAnalysisUnit,
      {content: reviewParser.parse(serializedAnalysisUnit.data), possibleTags: allTags}
    )
    new Monitoring.Models.SocialContents.AnalysisUnit attributes

  _createInstagramListening:(serializedAnalysisUnit, allTags) ->
    content = new Monitoring.Models.SocialContents.InstagramListeningMediaContent(serializedAnalysisUnit, allTags)
    #TODO: ESTO DE LOS TAGS ESTA BIEN???
    attributes = $.extend({}, serializedAnalysisUnit, { content: content, possibleTags: allTags })
    new Monitoring.Models.SocialContents.AnalysisUnit(attributes)

  _createLegacy: (socialContent, allTags) ->
    new Monitoring.Models.SocialContents.SocialContentFactory().create(socialContent, allTags)
